import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from '../button'
import Icon from '../icon'
import { ButtonIcons } from '../icons'

import './addbutton.scss'
class AddButton extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    let buttonProps = { ...this.props }
    let icon = null
    switch (this.props.size) {
      case 's':
        icon = this.props.style === 'link' ? ButtonIcons.Add_Plus_Link_16 : ButtonIcons.Add_Plus_16
        break
      case 'm':
        icon = this.props.style === 'link' ? ButtonIcons.Add_Plus_Link_20 : ButtonIcons.Add_Plus_20
        break
      case 'l':
        icon = this.props.style === 'link' ? ButtonIcons.Add_Plus_Link_24 : ButtonIcons.Add_Plus_24
        break
    }

    return (
      <div className='element-addbutton'>
        <Button {...buttonProps}>
          <Icon size={this.props.size} icon={icon} injectSvg />
        </Button>
      </div>
    )
  }
}

AddButton.defaultProps = {
  size: 'l',
  style: 'link',
  spacing: 0
}

// AddButton.contextTypes = {
//   router: React.PropTypes.object.isRequired
// }

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(AddButton)
// export default AddButton



// WEBPACK FOOTER //
// ./src/app/shared/elements/addButton/index.js